import { render, staticRenderFns } from "./SharedHeader.vue?vue&type=template&id=0c2a8bd0&scoped=true"
import script from "./SharedHeader.vue?vue&type=script&lang=ts"
export * from "./SharedHeader.vue?vue&type=script&lang=ts"
import style0 from "./SharedHeader.vue?vue&type=style&index=0&id=0c2a8bd0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2a8bd0",
  null
  
)

export default component.exports